import { trackAmplitudeEvent } from '../analytics/CustomEvents'

export default function initFiltersVisibilityToggle () {
  const columnCountToggle = document.getElementById('vjs-toggle-column-count')
  const singleColumnDisplayEnabled = document.getElementById('vjs-single-column-display-enabled')
  const doubleColumnDisplayEnabled = document.getElementById('vjs-double-column-display-enabled')
  const singleColumnDisplayDisabled = document.getElementById('vjs-single-column-display-disabled')
  const doubleColumnDisplayDisabled = document.getElementById('vjs-double-column-display-disabled')
  const hitsContainer = Array.from(document.getElementsByClassName('vjs-hits-container'))[0]

  if (!columnCountToggle || !hitsContainer) return

  columnCountToggle.addEventListener('click', () => {
    const experimentVariant = columnCountToggle.dataset.plpColumnVariant || null

    if (hitsContainer.classList.contains('vsd-listings__single-column')) {
      hitsContainer.classList.remove('vsd-listings__single-column')
      singleColumnDisplayEnabled.classList.add('hidden')
      singleColumnDisplayDisabled.classList.remove('hidden')
      doubleColumnDisplayEnabled.classList.remove('hidden')
      doubleColumnDisplayDisabled.classList.add('hidden')
      trackAmplitudeEvent('PLP Column Toggle Clicked', { new_layout: 'double', variant: experimentVariant })
    } else {
      hitsContainer.classList.add('vsd-listings__single-column')
      singleColumnDisplayEnabled.classList.remove('hidden')
      singleColumnDisplayDisabled.classList.add('hidden')
      doubleColumnDisplayEnabled.classList.add('hidden')
      doubleColumnDisplayDisabled.classList.remove('hidden')
      trackAmplitudeEvent('PLP Column Toggle Clicked', { new_layout: 'single', variant: experimentVariant })
    }
  })
}
